import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11 0C8.1 0 5.3 1.075 3.2 3.128A10.6 10.6 0 0 0 0 10.753c0 5.963 4.9 10.754 11 10.754 2.4 0 4.8-.782 6.7-2.249.4-.293.5-.977.2-1.368s-1-.49-1.4-.196c-1.6 1.173-3.5 1.857-5.5 1.857-5 0-9-3.91-9-8.798 0-2.346.9-4.594 2.6-6.256s4-2.542 6.4-2.542c5 0 9 3.91 9 8.798v.978c0 1.075-.9 1.955-2 1.955s-2-.88-2-1.955V6.843c0-.587-.4-.978-1-.978s-1 .391-1 .978a5.2 5.2 0 0 0-3-.978c-2.8 0-5 2.151-5 4.888s2.2 4.888 5 4.888c1.5 0 2.8-.684 3.7-1.662.7.978 1.9 1.662 3.3 1.662 2.2 0 4-1.76 4-3.91v-.978C22 4.79 17.1 0 11 0m0 13.686c-1.7 0-3-1.27-3-2.933S9.3 7.82 11 7.82s3 1.271 3 2.933-1.3 2.933-3 2.933"
    }, null, -1)
  ]))]))
}
export default { render: render }